import {ShortUser} from './ShortUser';
import {NewsCategory} from './NewsCategory';
import {Image} from './Image';
import {District} from './District';
import {LinkedEntity} from './LinkedEntity';
import {TeamSeason} from './TeamSeason';
import {Profile} from './Profile';
import {Match} from './Match';
import {Club} from './Club';
import {CompetitionSeason} from './CompetitionSeason';

interface NewsAttachment {
  readonly [imageOrMatchTag: string]: Image | Match;
}

export class News {
  readonly id: number;
  readonly slug: string;
  readonly linkUrl: string;
  readonly visible: boolean;
  readonly author?: ShortUser;
  readonly authorAlias: string;
  readonly category?: NewsCategory;
  readonly title: string;
  readonly subtitle: string;
  readonly teaserText: string;
  readonly text: string;
  readonly publishDate: string | null;
  readonly modifiedDate: string | null;
  readonly googlebot: string | null;
  readonly auto_redirect_url: string | null;
  readonly image: Image;
  readonly attachements?: NewsAttachment[]; // TODO: use explicit tags for image and match
  readonly links?: {
    competitions?: LinkedEntity<CompetitionSeason>[];
    teams?: LinkedEntity<TeamSeason>[];
    players?: LinkedEntity<Profile>[];
    news?: LinkedEntity<News>[];
    matches?: LinkedEntity<Match>[];
    districts?: LinkedEntity<District>[];
    clubs?: LinkedEntity<Club>[];
  };
}
